var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Setting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.13 53.16l3.81-6.6-5.27-5.79a16.669 16.669 0 00-.06-5.93l5.17-5.68-3.78-6.6-7.6 1.65a17.899 17.899 0 00-5.29-3L41.81 14h-7.62l-2.29 7.19a17.89 17.89 0 00-5.51 3.22l-7.19-1.57-3.81 6.6 5 5.48a17.272 17.272 0 00.06 6.55l-4.88 5.37 3.81 6.6 7.31-1.59a17.892 17.892 0 005.6 3.09L34.52 62h7.62l2.34-7.33a17.9 17.9 0 005.2-3.14l7.45 1.63zM38 50.1A12.1 12.1 0 1150.1 38 12.11 12.11 0 0138 50.1z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Setting.c13e243b.svg";
export { SvgJ2Setting as ReactComponent };